"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshUser = void 0;
var jwt_decode_1 = require("jwt-decode");
var api_1 = require("../../api");
var Helpers_1 = require("../../services/Helpers");
var userActions_1 = require("../actions/userActions");
var isTokenValid = function (token) {
    if (!token)
        return false;
    var decodedToken = (0, jwt_decode_1.default)(token);
    if (typeof decodedToken !== "object" || decodedToken === null)
        return false;
    return decodedToken["exp"] * 1000 >= Date.now();
};
var userInfo = null;
try {
    userInfo = localStorage.getItem("user_info") && JSON.parse(window.atob((_a = localStorage.getItem("user_info")) !== null && _a !== void 0 ? _a : ""));
}
catch (error) {
    userInfo = null;
}
if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.token) || !isTokenValid(userInfo.token)) {
    localStorage.removeItem("user_info");
    userInfo = null;
    api_1.OpenAPI.HEADERS = Helpers_1.HelpersService.authHeader();
}
else {
    api_1.OpenAPI.HEADERS = Helpers_1.HelpersService.authHeader(userInfo.token);
}
var initialUserState = { user: userInfo };
var userReducer = function (state, action) {
    if (state === void 0) { state = initialUserState; }
    switch (action.type) {
        case userActions_1.SET_USER:
            if (!isTokenValid(action.payload.token)) {
                localStorage.removeItem("user_info");
                return __assign(__assign({}, state), { user: null });
            }
            localStorage.setItem("user_info", window.btoa(JSON.stringify(action.payload).replace(/[^\x00-\x7F]/g, "")));
            api_1.OpenAPI.HEADERS = Helpers_1.HelpersService.authHeader(action.payload.token);
            return __assign(__assign({}, state), { user: action.payload });
        case userActions_1.UPDATE_USER_DATA:
            action.payload.token = state.user.token;
            localStorage.setItem("user_info", window.btoa(JSON.stringify(action.payload).replace(/[^\x00-\x7F]/g, "")));
            return __assign(__assign({}, state), { user: action.payload });
        case userActions_1.UPDATE_USER_PHOTO:
            var updatedUser = state.user;
            updatedUser.photo = action.payload;
            localStorage.setItem("user_info", window.btoa(JSON.stringify(updatedUser).replace(/[^\x00-\x7F]/g, "")));
            return __assign(__assign({}, state), { user: updatedUser });
        case userActions_1.LOGOUT_USER:
            localStorage.removeItem("user_info");
            localStorage.removeItem("userPicture");
            return __assign(__assign({}, state), { user: null });
        default:
            return state;
    }
};
//TODO: add as another reducer when needed
var refreshUser = function () {
    return function (dispatch, getState) {
        var token = getState().user.token.token;
        if (!isTokenValid(token)) {
            localStorage.removeItem("user_info");
            return Promise.reject("Token is not valid");
        }
        // TODO: Add the logic to refresh the user data using the token
        // For example, you can call an API endpoint to get the updated user data
        // and dispatch the setUser action with the new data.
        // You can use Axios or any other HTTP library for this.
        return Promise.resolve(); // Replace this with the actual API call
    };
};
exports.refreshUser = refreshUser;
exports.default = userReducer;
//# sourceMappingURL=userReducers.js.map